import { Button, Flex } from "antd"
import PropTypes from "prop-types"
import { spacings } from "themes/variables"
import CustomDrawer from "ui/Drawer"
import { routes } from "router/routes"
import { useNavigate } from "react-router-dom"

const getTableActions = (handleActionClick) => [
  {
    label: "View",
    color: "primary",
    variant: "outlined",
    onClick: () => {
      handleActionClick("view")
    },
  },
  {
    label: "Edit",
    color: "primary",
    variant: "outlined",
    onClick: () => {
      handleActionClick("edit")
    }
  },
  {
    label: "Add to Group",
    color: "primary",
    variant: "outlined",
    onClick: () => {
      handleActionClick("add_to_group")
    }
  },
  {
    label: "Remove from Group",
    color: "primary",
    variant: "outlined",
    onClick: () => {
      handleActionClick("remove_from_group")
    }
  },
  {
    label: "Message",
    color: "primary",
    variant: "outlined",
    onClick: () => {
      handleActionClick("message")
    }
  },
  {
    label: "Text",
    color: "primary",
    variant: "outlined",
    onClick: () => {
      handleActionClick("text")
    }
  },
  {
    label: "Delete",
    color: "danger",
    variant: "outlined",
    onClick: () => {
      handleActionClick("delete")
    }
  }
]

const getMoreActions = (navigate) => [
  {
    label: "Manage Groups",
    color: "primary",
    variant: "outlined",
    onClick: () => {
      navigate(routes.guideClientManageGroup())
    }
  }
]

const getActions = ({ actionType, handleActionClick, navigate }) => {
  if (actionType === "actions") {
    return getTableActions(handleActionClick)
  } else if (actionType === "moreActions") {
    return getMoreActions(navigate)
  }
}

const ActionDrawers = ({ actionType = "actions", open, setOpen, handleActionClick }) => {
  const navigate = useNavigate();
  const actions = getActions({ actionType, handleActionClick, navigate })
  return (
    <CustomDrawer open={open} setOpen={setOpen} title="More Actions">
      <Flex vertical gap={spacings.M}>
        {actions.map((action) => (
          <Button
            key={action.label}
            color={action.color}
            variant={action.variant}
            className={`w-full py-l ${actions.length === 1 ? "my-5xl" : ""}`}
            onClick={action.onClick}
            disabled={action.disabled}
          >
            {action.label}
          </Button>
        ))}
      </Flex>
    </CustomDrawer>
  )
}

ActionDrawers.propTypes = {
  actionType: PropTypes.oneOf(["actions", "moreActions"]),
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  handleActionClick: PropTypes.func
}

export default ActionDrawers
